import React, { useEffect } from 'react'

import emitter from 'common/util/events'
import UnsupportedModal from 'components/shared/UnsupportedModal'
import { useFlag } from 'components/contexts/flag/Flag'
import { useCommitteesState } from 'components/contexts/committee-context'
import { isDeviceRestricted } from 'common/util/user-agent'
import { checkValidPlatform } from 'common/util/platform'
import NotFound from 'pages/NotFound/NotFound'

type Props = {
    platform: Platform
    inProgress?: boolean
    children: any
    onLoadedSuccessful: (...args: any) => void
}
/**
 * Conditional rendering of the App and and it's lock states
 */
export const AppLock = (props: Props) => {
    const isTabletRestricted = useFlag('isTabletRestricted')
    const { loading: loadingCommittees, committees } = useCommitteesState()

    useEffect(() => {
        props.onLoadedSuccessful()
    })

    // Block mobile devices
    const isDeviceBlocked = isDeviceRestricted(navigator.userAgent, isTabletRestricted)

    if (isDeviceBlocked) {
        return <UnsupportedModal />
    }

    const isValidPlatform = checkValidPlatform(props.platform)
    const hasNoCommittees = !loadingCommittees && committees?.length === 0

    // Show NotFound page when user has no committees
    if (hasNoCommittees) {
        return <NotFound hasCommittee={false} />
    }

    // App is locked probably from not being authorized
    if (!isValidPlatform) {
        emitter.emit('locked')
        return null
    }

    // Not all data is retrieved yet but we are working on it (committee id)
    if (props.inProgress || loadingCommittees) {
        return null
    }

    return props.children
}
